import React from 'react';
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { Merchant, Card } from 'model';

import { ImageAsset, SVGAsset } from "res";
import { UIIconButton } from 'components/ui/UIButton';

import "./styles.css";

/**
 * @function MerchantDetailsView
 * @param {STRING} logo - This is the logo of the biller.
 * @param {STRING} name - This is the name of the biller.
 * @param {STRING} cardName - This is the card name tha was used to make the purchase.
 * @param {STRING} cardNumber - This is the last four digits of the card number tha was used to make the purchase.
 * @param {React.Component} children - React components that goes under the card name.
 * @return {React.Component}
 * @exported true
 * @description This is a details view for transactions.
 * @example
 * <MerchantDetailsView logo="PizzaPlace" name="Pizza Place" cardName="Credit Card" cardNumber="*5678">Recurring Payments</MerchantDetailsView>
 */
export default function MerchantDetailsView(props) {
  const merchant = props.merchant ?? Merchant.firstInstanceOf();
  const card = props.card ?? Card.firstInstanceOf();

  const cardName = `${ card.type.charAt(0).toUpperCase() }${ card.type.slice(1) }`;

  return (
    <div className="merchant-details-view text-center">
      <ImageAsset id={ merchant.logo } className="biller-logo" />
      <p className="biller-name"><b>{ merchant.name }</b></p>
      <p className="card-name"><b>{ cardName } { card.maskedNumber }</b></p>
      <p className="frequency">{props.children}</p>
      <div className="flex-container divider">
        <div className="set-width button-container">
          <DisabledPrompt>
            <UIIconButton className="set-width" icon={<SVGAsset id="PhoneIcon" />} text="Call" />
          </DisabledPrompt>
        </div>
        <div className="set-width text-center button-container">
          <DisabledPrompt>
            <UIIconButton className="set-width" icon={<SVGAsset id="EnvelopeIcon" />} text="Email" />
          </DisabledPrompt>
        </div>
        <div className="set-width button-container">
          <DisabledPrompt>
            <UIIconButton icon={<SVGAsset id="OutsideLinkIcon" />} text="Website" />
          </DisabledPrompt>
        </div>
      </div>
    </div>
  );
}